'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, EmptyState } from '@/shared/components/ui';
import { FeatherAlertCircle, FeatherRotateCcw } from '@subframe/core';
interface NegociacaoDetailErrorStateProps {
  onRetry: () => void;
}
export function NegociacaoDetailErrorState(t0) {
  const $ = _c(4);
  const {
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherAlertCircle className="text-error-600" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherRotateCcw />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onRetry) {
    t3 = <div className="flex h-full w-full items-center justify-center"><EmptyState icon={t1} title={"Erro ao carregar negocia\xE7\xE3o"} description={"N\xE3o foi poss\xEDvel recuperar as informa\xE7\xF5es desta negocia\xE7\xE3o no momento."} action={<Button variant="neutral-secondary" onClick={onRetry} icon={t2}>Tentar novamente</Button>} /></div>;
    $[2] = onRetry;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}